import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Validate Firebase configuration
const validateFirebaseConfig = (config) => {
  const requiredKeys = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
  ];

  requiredKeys.forEach((key) => {
    if (!config[key]) {
      throw new Error(`Missing Firebase configuration for ${key}`);
    }
  });
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

validateFirebaseConfig(firebaseConfig);

const app = initializeApp(firebaseConfig);

/**
 * TEMPORARY: App Check disabled
 * - No reCAPTCHA
 * - No debug token
 * IMPORTANT: In Firebase Console → App Check, set APIs (Auth/Firestore/etc.)
 * to "Unenforced" (or "Monitor") otherwise requests may still be blocked.
 */
console.log("App Check is TEMPORARILY DISABLED.");

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const realtimeDB = getDatabase(app);
export default app;
